import React, { useState } from 'react';
import IngredientsForm from './ingredientsFormInput';
import { KitchenLogo } from '../../../assets/icons/kitchenLogo';

const SearchBar = ({ searchRecipes, searchMode, setSearchMode }) => {
  const [ingredient, setIngredient] = useState('');
  const [ingredients, setIngredients] = useState([]);

  const handleIngredientSubmit = (e) => {
    e.preventDefault();
    setIngredients([...ingredients, ingredient.toLowerCase()]);
    console.log(ingredient);
    setIngredient('');
  };

  const handleIngredientsSubmit = (e) => {
    e.preventDefault();
    searchRecipes(ingredients);
  };

  const handleDelete = (id) => {
    const editedList = ingredients.filter((i) => i !== id);
    setIngredients(editedList);
  };

  return (
    <div className="search-bar">
      <div className="header">
        <div className="brand-logo">
          <KitchenLogo fill="white" width="35" />
          <h2>
            let's <span>COOK</span>
          </h2>
        </div>
        {!searchMode ? (
          <div className="btn-back">
            <span onClick={() => setSearchMode(true)}>Search Again</span>
          </div>
        ) : null}
      </div>
      {searchMode ? (
        <div>
          <IngredientsForm
            handleIngredientSubmit={handleIngredientSubmit}
            handleIngredientsSubmit={handleIngredientsSubmit}
            ingredient={ingredient}
            ingredients={ingredients}
            setIngredient={setIngredient}
            handleDelete={handleDelete}
          />
          <div className="chips">
            <p className="headline">1. Add Ingredients:</p>
            {!!ingredients &&
              ingredients.map((ingredient) => {
                return (
                  <ul className="items-added">
                    <li key={ingredient}>{ingredient}</li>
                    <span onClick={() => handleDelete(ingredient)}>remove</span>
                  </ul>
                );
              })}
            {!!ingredients.length && (
              <button
                className="btn-submit"
                type="submit"
                onClick={handleIngredientsSubmit}>
                Search
              </button>
            )}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default SearchBar;
